import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { COLORS } from '../styles/theme';

export function LoginPage() {
  const { signIn, error, loading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError('');

    if (!email || !password) {
      setLocalError('Email and password are required');
      return;
    }

    try {
      await signIn(email, password);
    } catch {
      // Error is already set in context
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoSection}>
          <div style={styles.logo}>GL</div>
          <h1 style={styles.title}>Grimsthorpe Lake</h1>
          <p style={styles.subtitle}>Admin Dashboard</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ryan.merpaw@admin.grimsthropelake.com"
              style={styles.input}
              autoFocus
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              style={styles.input}
            />
          </div>

          {(localError || error) && (
            <div style={styles.error}>{localError || error}</div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.button,
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={styles.footer}>Owner access only</p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: `linear-gradient(135deg, ${COLORS.primaryGreen} 0%, ${COLORS.backgroundPrimary} 50%, ${COLORS.primaryGreen} 100%)`,
    padding: 20,
  },
  card: {
    width: 400,
    maxWidth: '100%',
    backgroundColor: COLORS.backgroundSecondary,
    borderRadius: 16,
    border: `1px solid ${COLORS.borderDefault}`,
    padding: 40,
  },
  logoSection: {
    textAlign: 'center' as const,
    marginBottom: 32,
  },
  logo: {
    width: 56,
    height: 56,
    borderRadius: 12,
    backgroundColor: COLORS.primaryGreen,
    color: COLORS.textGold,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 800,
    fontSize: 20,
    letterSpacing: 2,
    marginBottom: 16,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: COLORS.textPrimary,
    margin: 0,
  },
  subtitle: {
    fontSize: 13,
    color: COLORS.brass,
    fontWeight: 600,
    textTransform: 'uppercase' as const,
    letterSpacing: 2,
    marginTop: 4,
  },
  form: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 20,
  },
  field: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 6,
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    color: COLORS.textMuted,
    textTransform: 'uppercase' as const,
    letterSpacing: 0.5,
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    backgroundColor: COLORS.backgroundTertiary,
    border: `1px solid ${COLORS.borderDefault}`,
    borderRadius: 8,
    color: COLORS.textPrimary,
    fontSize: 14,
    outline: 'none',
    boxSizing: 'border-box' as const,
  },
  error: {
    padding: '10px 14px',
    backgroundColor: 'rgba(220, 53, 69, 0.1)',
    border: '1px solid rgba(220, 53, 69, 0.3)',
    borderRadius: 8,
    color: COLORS.statusError,
    fontSize: 13,
  },
  button: {
    width: '100%',
    padding: '12px 24px',
    backgroundColor: COLORS.primaryGreen,
    color: COLORS.textGold,
    border: 'none',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    textTransform: 'uppercase' as const,
    letterSpacing: 1,
    marginTop: 8,
  },
  footer: {
    textAlign: 'center' as const,
    marginTop: 24,
    fontSize: 11,
    color: COLORS.textMuted,
    textTransform: 'uppercase' as const,
    letterSpacing: 1,
  },
};
